<template>
  <v-container>
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="10" lg="4">
          <div class="layout column align-center">
            <img
              src="../../assets/log.png"
              alt="Vue Material Admin"
              height="140px"
              width="155px"
            />

            <v-card width="400px" class="pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <h1 class="flex my-4 black--text">Iniciar Sesión</h1>
                </div>
                <v-form v-model="valid">
                  <v-text-field
                    color="#F28122"
                    prepend-icon="perm_identity"
                    name="login"
                    label="Cedula"
                    v-mask="'DDD-DDDDDDD-D'"
                    type="text"
                    v-model="userEmail"
                    :error="error"
                    :rules="[rules.required]"
                  />
                  <v-text-field
                    color="#F28122"
                    :type="hidePassword ? 'password' : 'text'"
                    :prepend-icon="
                      hidePassword ? 'visibility_off' : 'visibility'
                    "
                    name="password"
                    label="Contraseña"
                    id="password"
                    :rules="[rules.required]"
                    v-model="password"
                    :error="error"
                    @click:append="hidePassword = !hidePassword"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  block
                  v-shortkey="['enter']"
                  @shortkey="login()"
                  @click="login()"
                  dark
                  color="orange"
                  :loading="loading"
                  >Entrar</v-btn
                >
              </v-card-actions>
              <div class="layout column align-center">
                <v-btn block color="primary" to="/register"
                  >Crea una cuenta</v-btn
                >
              </div>
              <!-- <v-btn to="/resetpassword" text color="primary">He olvidado mi contraseña</v-btn> -->
              <div class="layout column">
                <p class="flex my-4 black--text">
                  A continuación acepto las condiciones de uso y politicas de
                  privacidad.
                </p>
              </div>
            </v-card>
            <v-card width="400px" class="my-3" flat>
              <v-card-actions></v-card-actions>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="showResult" :color="color" :timeout="5000" bottom>
      {{ result }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({
    color: "",
    emailRules: [
      (v) => !!v || "El correo es requerido",
      (v) => /.+@.+/.test(v) || "Debe ser un correo valido",
    ],
    valid: false,
    loading: false,
    userEmail: "",
    password: "",
    hidePassword: true,
    error: false,
    showResult: false,
    result: "",
    rules: {
      required: (value) => !!value || "Campo requerido.",
      email: "",
    },
  }),

  mounted() {
    this.validateUser();
  },
  computed: mapState({
    user: (state) => state.user,
  }),
  methods: {
    ...mapActions(["loginMethod"]),
    async login() {
      let self = this;
      if (this.valid) {
        if (this.validateCardId()) {
          this.loading = true;
          let login = {
            identificationCard: this.userEmail,
            password: this.password,
          };

          const response = await this.loginMethod(login);

          if (response) {
            self.loading = false;
            self.$router.push({
              name: "account",
            });
          } else {
            self.color = "error";
            self.showResult = true;
            self.loading = false;
            self.result = "email/contraseña invalidos";
          }
        } else {
          self.color = "Informacion";
          self.showResult = true;
          self.loading = false;
          self.result = "Cedula invalidad";
        }
      } else {
        self.color = "error";
        self.showResult = true;
        self.loading = false;
        self.result = "No valido";
      }
    },
    validateUser() {
      let self = this;
      if (this.user.identificationCard) {
        debugger;
        self.$router.push({
          name: "account",
        });
      }
    },
    validateCardId() {
      if (this.userEmail.length == 13) {
        return true;
      }
      return false;
    },
  },
};
</script>
